import React from 'react';
import AppLayout from '../components/AppLayout';
import WindowAnalytics from '../components/reports/WindowAnalytics';

export default function ReportsPage() {
  return (
    <AppLayout title="Reports" breadcrumb="Dashboard › Reports">
      <WindowAnalytics />
    </AppLayout>
  );
}
